import { Component, OnInit, Input,OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActuationOperation } from 'app/modules/common/enums/actuationOperation';
import { FileService } from '../../../../common/services/file.service';
import { FileFormatEnum } from 'app/modules/common/enums/file-format-enum';

@Component({
    selector: 'app-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss'],
    standalone: false
})
export class DocumentComponent implements OnInit,OnChanges {
  @Input() EmployeeFormGroup: UntypedFormGroup;
  @Input() ActuationOperation:number;

  file: any;
  VisiblePanel:boolean;
  public FileFormatEnum = FileFormatEnum;
  constructor(public fb: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private fileService:FileService) {
  }

  ngOnChanges() {
    if(this.EmployeeFormGroup && this.ActuationOperation) {
      if(
        this.ActuationOperation === Number(ActuationOperation.VisitaAusente)
        || this.ActuationOperation === Number(ActuationOperation.InformeMedico)
        || this.ActuationOperation === Number(ActuationOperation.DocumentoNoMedico)
        || this.ActuationOperation === Number(ActuationOperation.SmsEntregado)
        || this.ActuationOperation === Number(ActuationOperation.SmsNoEntregado)
      ) {
        this.VisiblePanel = true;
      } else {
        this.VisiblePanel = false;
        this.ConfigForm();
      }
    }
  }

  ngOnInit() {
  }

  private ConfigForm() {
    this.EmployeeFormGroup.removeControl('Document');
  }

  public ShowSnackBar(message: string, action: string, duration: number) {
    return this.snackBar.open(message, action, {
      duration: duration
    });
  }

  // Document part

  uploadFile(event) {
    this.readFile(event[0]);
  }

  private readFile(file) {
    const currentContext = this;
    const fileReader = new FileReader();
    fileReader.onload = function (event) {
      currentContext.file = file.name;
      currentContext.EmployeeFormGroup.get(['Document', 'File']).patchValue(currentContext.fileService.arrayBufferToBase64(fileReader.result));
      currentContext.EmployeeFormGroup.get(['Document', 'Type']).patchValue(currentContext.fileService.getFileExtention(file.type));
    };
    //if (currentContext.fileService.getFileExtention(file.type) === 'PDF') {
    if (FileFormatEnum.TrabajadorControllerDocumentoTS.includes(currentContext.fileService.getFileExtention(file.type))) {
      fileReader.readAsArrayBuffer(file);
    }
    else {
      currentContext.ShowSnackBar('No se puede aceptar este tipo de archivo', 'Okay', 1500);
    }
  }

  deleteAttachment() {
    this.file = undefined;
    this.EmployeeFormGroup.get(['Document', 'File']).patchValue('');
    this.EmployeeFormGroup.get(['Document', 'Type']).patchValue('');
  }


}
